import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "px-6 py-2"
};
const _hoisted_2 = {
  class: "panel"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "panel"
};
const _hoisted_5 = {
  key: 0,
  class: "h-5/6 mx-4"
};
const _hoisted_6 = {
  class: "table table-hover stylized chosen-remove-margin"
};
const _hoisted_7 = {
  class: "text-slate-700"
};
const _hoisted_8 = {
  key: 0,
  class: "mb-4 mt-2 text-sm text-left text-yellow-800 dark:bg-gray-800 dark:text-yellow-300",
  role: "alert"
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "flex justify-end mx-4"
};
const _hoisted_11 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_main_header = _resolveComponent("main-header");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  const _component_product_notice = _resolveComponent("product-notice");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_main_header, {
    content: "API"
  }), _createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createTextVNode(" API keys are used to authenticate third party services against LeanLaw public API. ", -1)), _createElementVNode("div", null, [_createVNode(_component_LlSecondaryButton, {
    variant: "text",
    color: "primary",
    "prepend-icon": "mdi-open-in-new",
    onClick: _cache[0] || (_cache[0] = $event => $options.openDocumentation())
  }, {
    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" API Documentation ", -1)]))]),
    _: 1
  })])]), _createVNode(_component_product_notice, {
    state: $props.state,
    label: 'Access to the LeanLaw API is',
    product: 'api'
  }, null, 8, ["state"]), $data.me.features?.api ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$data.apiKeys.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[6] || (_cache[6] = _createElementVNode("h4", null, "API Keys", -1)), _createElementVNode("table", _hoisted_6, [_cache[5] || (_cache[5] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "Label"), _createElementVNode("th", null, "Api Key"), _createElementVNode("th", null, "Created"), _createElementVNode("th")])], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.apiKeys, apiKey => {
    return _openBlock(), _createElementBlock("tbody", {
      key: apiKey.id
    }, [_createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(apiKey.label), 1), _createElementVNode("td", null, [_createElementVNode("span", _hoisted_7, _toDisplayString(apiKey.key.replace(/\*/g, '•')), 1), apiKey.newKey ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [_createElementVNode("path", {
      d: "M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"
    })], -1), _createElementVNode("span", {
      class: "font-bold"
    }, "Please save this key somewhere safe!", -1), _createTextVNode(" For security reasons, we will not show it again. ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("td", null, _toDisplayString($options.getLocaleDate(apiKey.date)), 1), _createElementVNode("td", null, [apiKey.newKey ? (_openBlock(), _createBlock(_component_LlSecondaryButton, {
      key: 0,
      icon: "mdi-content-copy",
      variant: "text",
      size: "small",
      title: "Copy key to clipboard.",
      "aria-label": "Copy API key to clipboard",
      onClick: $event => $options.copyToClipboard(apiKey)
    }, null, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_LlSecondaryButton, {
      icon: "mdi-pencil",
      variant: "text",
      size: "small",
      title: "Edit key.",
      "aria-label": "Edit API key",
      onClick: $event => $options.updateApiKey(apiKey)
    }, null, 8, ["onClick"]), _createVNode(_component_LlSecondaryButton, {
      icon: "mdi-delete",
      variant: "text",
      size: "small",
      color: "error",
      title: "Delete key.",
      "aria-label": "Delete API key",
      onClick: $event => $options.deleteApiKey(apiKey)
    }, null, 8, ["onClick"])])])]);
  }), 128))])])) : (_openBlock(), _createElementBlock("p", _hoisted_9, "You do not have any API keys assigned.")), _createElementVNode("div", _hoisted_10, [_createVNode(_component_LlSecondaryButton, {
    onClick: _cache[1] || (_cache[1] = $event => $options.generateApiKey()),
    disabled: $data.isProcessing,
    color: "primary"
  }, {
    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Generate API Key ", -1)]))]),
    _: 1
  }, 8, ["disabled"]), $data.isProcessing ? (_openBlock(), _createElementBlock("p", _hoisted_11, [...(_cache[8] || (_cache[8] = [_createElementVNode("span", {
    class: "fa fa-cog fa-spin"
  }, null, -1), _createTextVNode(" Processing... ", -1)]))])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]);
}